import { render, staticRenderFns } from "./BanksListLoadingModal.vue?vue&type=template&id=dfbe4590"
import script from "./BanksListLoadingModal.vue?vue&type=script&lang=js"
export * from "./BanksListLoadingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports